




















import { Component, Vue, Prop } from 'vue-property-decorator'
import router from '@/router'
import ShowImg from '../ui/ShowImg.vue'
@Component({
  components: {
    ShowImg
  }
})
export default class Recommend extends Vue {
  @Prop()
  public dataList: any
  public created() {
    // console.log(this.dataList)
  }

  protected goDetails(item: any) {
    this.$router.push({ name: 'goods-details', query: { id: item.id } })
  }

}
